




import { Component, Vue } from "vue-property-decorator";

import CampaignOverview from "@/components/CampaignOverview.vue";

@Component({
  components: {
    CampaignOverview,
  },
})
export default class CampaignDetails extends Vue {}
